// Funzione "Collettore" leggera
export function initVideoPlugin() {
    // 1. Check di esistenza ultra-rapido
    // Usiamo querySelector invece di querySelectorAll perché ci basta sapere se ne esiste UNO.
    const hasVideoComponents = document.querySelector('.video-box');

    // 2. Se non ci sono video, ci fermiamo qui. Risparmiamo banda e CPU.
    if (!hasVideoComponents) {
        return;
    }

    // 3. Import Dinamico
    // Scarica il file JS solo ora
    import('./video_box.js')
        .then(module => {
            // Esegue la funzione default esportata dal modulo
            module.default();
        })
        .catch(err => {
            console.error('Errore nel caricamento del Video Plugin:', err);
        });
}
